<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">姓名</span>
        <el-input v-model.trim="name" placeholder="请输入姓名" style="width: 150px;"/>
      </div>

     <div class="dlblock-mb20 mr10">
        <span class="pr5">手机号</span>
        <el-input v-model.trim="phone" placeholder="请输入手机号" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">批次号</span>
        <el-input v-model.trim="batch" placeholder="请输入批次号" style="width: 150px;"/>
      </div>
	  

	   <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
			class="reset-clear"
			:clearable="false"
			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始日期"
	        />
	  </div> 
	  

	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
          v-model="updateTime"
		  style="width: 180px;"
          type="datetime"
          :clearable="false"
          unlink-panels
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
           />
	  </div> 

      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getCanteenSmsListPageFn()">
          搜索
        </el-button>
      </div>
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="editBtn(1)">
          发送短信excel上传
        </el-button>
      </div>
	  
	<!--  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(2)">
	      上传交易流水
	    </el-button>
	  </div>

    <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(3)">
	      上传人脸识别日志一楼
	    </el-button>
	  </div>
	  
	  <div class="dlblock-mb20 mr10">
	      <el-button type="primary" @click="editBtn(4)">
	        上传人脸识别日志二楼
	      </el-button>
	    </div> -->

    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="id" label="编号"></el-table-column>
	  <el-table-column align="center" prop="name" label="名称"></el-table-column>
    <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
    <el-table-column align="center" prop="balance" label="余额"></el-table-column>
	  <el-table-column align="center" prop="batch" label="批次"></el-table-column>
    <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
     
     <!-- <el-table-column align="center" width="150" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a"  @click="editBtn(2, row)">修改</a>
          <a class="glob-a"  @click="auditShow = {modal: true, data: row}">查看</a>
		   <a class="glob-a"  @click="editBtn(5, row)">删除</a>
        </template>
      </el-table-column> --> 
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

 
  <!-- 上传银行食堂员工余额发送短信 -->
    <el-dialog :title="editData.add === 1 ? '上传用户余额发送短信' : '编辑'" :visible.sync="editData.modal" width="500px">
      <el-form label-width="150px">
        <el-form-item label="文件：">
			<el-row>
			  <word-img class="mr10 mb10" v-model="editData.picture" :balance="balance" :total="1"/>
			</el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
	
	<!-- 上传食堂银行交易流水 -->
	  <el-dialog :title="canteen.add === 1 ? '上传银行食堂交易流水' : '编辑'" :visible.sync="canteen.modal" width="500px">
	    <el-form label-width="150px">
	      <el-form-item label="文件：">
				<el-row>
				  <trans-action class="mr10 mb10" v-model="canteen.picture" :balance="balance" :total="1"/>
				</el-row>
	      </el-form-item>
	    </el-form>
	  </el-dialog>


    
    	<!-- 上传人脸识别日志一楼 -->
	  <el-dialog :title="faceRecognitionLog.add === 1 ? '上传人脸识别日志一楼' : '编辑'" :visible.sync="faceRecognitionLog.modal" width="500px">
	    <el-form label-width="150px">
	      <el-form-item label="文件：">
				<el-row>
				  <face-reco class="mr10 mb10" v-model="faceRecognitionLog.picture" :balance="balance" :total="1"/>
				</el-row>
	      </el-form-item>
	    </el-form>
	  </el-dialog>
	  
	  <!-- 上传人脸识别日志二楼 -->
	  <el-dialog :title="faceRecognitionLogTwo.add === 1 ? '上传人脸识别日志二楼' : '编辑'" :visible.sync="faceRecognitionLogTwo.modal" width="500px">
	    <el-form label-width="150px">
	      <el-form-item label="文件：">
	  				<el-row>
	  				  <face-reco class="mr10 mb10" v-model="faceRecognitionLogTwo.picture" :balance="12" :total="1"/>
	  				</el-row>
	      </el-form-item>
	    </el-form>
	  </el-dialog>


  </div>
</template>

<script>
  import {
    getCanteenSmsListPage,
    addOrEditWordform,
	getEnwordMarkDelete,
	getEnWordInspect
  } from '@/api'

   import WordImg from '@/components/agriculturalBankFile.vue'
   import TransAction from '@/components/transactionFlowBankFile.vue'
   import FaceReco from '@/components/faceRecognitionLog.vue'

  export default {
    name: 'WordList',
    components: {WordImg,TransAction,FaceReco},
    data () {
      return {
        balance:10,
        name:'',
        phone:'',
        batch:'',
        createTime:'',
		updateTime:'',
		word:'',
		chinese:'',
        date: '',
        userName: '',
        tableData: [],
        tableLoading: false,
        auditData: {
          modal: false,
          data: {},
          type: 'PASS',
          content: ''
        },
        auditShow: {
          modal: false,
          data: {}
        },
		//单词新增和修改
        editData: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
		//银行食堂上传交易流水
		canteen: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
     //银行食堂上传人脸识别日志一楼
		faceRecognitionLog: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
	//银行食堂上传人脸识别日志二楼
		faceRecognitionLogTwo: {
		     modal: false,
		     userId: '',
		     add: 1,
		     word: '',
		     chinese: '',
		     picture: []
		   },
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		imgTotal: 1,
		// 图片上传
		imgUploadData: {
		  modal: false,
		  urlList: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
      }
    },
     watch: {
            // 如果 `question` 发生改变，这个函数就会运行
            balance: function () {               
                
            }
        },
    created () {
      this.getCanteenSmsListPageFn()
    },
    methods: {
      getCanteenSmsListPageFn () {
        this.tableLoading = true
        getCanteenSmsListPage({
          pageNum: this.pages.page,
          createTime: this.createTime,
          updateTime: this.updateTime,
          name: this.name,
          phone: this.phone,
          batch:this.batch
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  getEnwordMarkDeleteFn (id) {
	    this.tableLoading = true
	    getEnwordMarkDelete(id).then(res => {
	     this.$message.success(res.msg)
	     this.getCanteenSmsListPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  editBtn(t,row) {
		  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除 6图片检查并下载
		  if(t == 1){
        //上传用户余额发送短信通知
			 this.editData = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			 }
		  }else if(t == 2){
        //上传银行食堂交易流水
			  console.info(row,"上传银行食堂交易流水")
			  this.canteen = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			  }
		  }else if(t == 3) {
        //上传人脸识别日志一楼
	     this.faceRecognitionLog = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			  }
	    }else if(t == 4) {
		//上传人脸识别日志二楼	
	   this.faceRecognitionLogTwo = {
	   			   modal: true,
	   			   userId: '',
	   			   add: 1,
	   			   word: '',
	   			   chinese: '',
	   			   picture: []
	   			  }
	    }else if(t == 5){
			this.$confirm(`确认要删除吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
				 let id =  row.id
			     this.getEnwordMarkDeleteFn(id);
			});	
		}
	},
	addBtn (t) {
	  if (this.editData.add == 1) {
	    addOrEditWordform({
	      word: this.editData.word,
	      chinese: this.editData.chinese,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.data)
	      this.getCanteenSmsListPageFn()
	    })
	  } else {
	    addOrEditWordform({
	      id: this.editData.id,
	      word: this.editData.word,
	      chinese: this.editData.chinese,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.data)
	      this.getCanteenSmsListPageFn()
	    })
	  }
	},
	uploadSave() {
	  if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
	    addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
	      this.$message.success(res.data)
	      this.imgUploadData.modal = false
	      this.getImagePageFn()
	    })
	  }
	},
      pageChange (val) {
        this.pages.page = val
        this.getCanteenSmsListPageFn()
      }
    }
  }
</script>

<style scoped>
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
